// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const MasterUploadCreate = lazy(
  () => import('pages/masterUpload/MasterUpload')
);
const MasterUploadRoute = (
  <Route
    index
    path={routeName.masterUpload}
    element={
      <PrivateRoute name={PrivateRouteConst.MASTER_FILE_UPLOAD}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <MasterUploadCreate />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default MasterUploadRoute;
